import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-gray-800 text-xl tracking-tighter" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 text-gray-600"
}
const _hoisted_3 = { class: "space-y-6 flex mt-4 flex-col" }
const _hoisted_4 = { class: "text-lg ml-2" }

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import { clearAuthToken } from '@/helpers/authToken'
import api from '@/store/api'


export default {
  __name: 'StripeIntegrationRequired',
  setup(__props) {

const router = useRouter()
const sessionUrl = ref(null)
const plan = ref(null)

// BOT-1697: the session is created on load so the page can name the plan the
// merchant chose; the button then goes straight to it.
const loadSession = () =>
  api.call('GET', 'stripe_checkout_session').then(response => {
    sessionUrl.value = response.data.session_url
    plan.value = response.data.plan || null
    return response.data.session_url
  })

const trialCopy = computed(() => (plan.value ? `${plan.value.trial_days} day free trial` : ''))
const monthlyCopy = computed(() => {
  if (!plan.value) return ''
  const fee = Number(plan.value.monthly_fee)
  const digits = Number.isInteger(fee) ? 0 : 2
  return `$${fee.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}/month`
})
// The bullets follow the chosen plan's feature list; legacy merchants without a
// plan keep the generic pitch.
const GENERIC_BULLETS = [
  'Power your e-commerce, customer communication, and backend from one easy-to-navigate dashboard',
  'Experience first-hand the power of memberships, drops, and texting for recurring orders',
  'Free, unlimited email access to our customer support team',
  'Cancel your account at any point, risk-free'
]
const bullets = computed(() => {
  const features = plan.value && Array.isArray(plan.value.features) ? plan.value.features.filter(Boolean) : []
  return features.length ? features : GENERIC_BULLETS
})
const headline = computed(() =>
  plan.value
    ? `Add a payment method to start your ${trialCopy.value}`
    : 'Add a payment method to start your 14-day free trial'
)

const signUp = async () => {
  const url = sessionUrl.value || (await loadSession())
  window.location.href = url
}

const signOut = () => {
  clearAuthToken()
  router.push('/login')
}

onMounted(() => {
  loadSession().catch(() => {})
})

fbq('trackCustom', 'StartTrialPage')

return (_ctx, _cache) => {
  const _component_SignupMainContainer = _resolveComponent("SignupMainContainer")

  return (_openBlock(), _createBlock(_component_SignupMainContainer, {
    title: "Payment method required",
    "image-position": "left"
  }, {
    body: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(headline.value), 1),
      (plan.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(plan.value.name) + " plan: " + _toDisplayString(trialCopy.value) + ", then " + _toDisplayString(monthlyCopy.value) + ". Cancel any time from Settings. ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bullets.value, (bullet) => {
          return (_openBlock(), _createElementBlock("div", {
            key: bullet,
            class: "flex items-center"
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-6 w-6" }, [
              _createElementVNode("svg", {
                class: "h-6 w-6 text-green-500",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M4.5 12.75l6 6 9-13.5"
                })
              ])
            ], -1)),
            _createElementVNode("p", _hoisted_4, _toDisplayString(bullet), 1)
          ]))
        }), 128))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", { class: "flex justify-between items-center w-full" }, [
        _createElementVNode("button", {
          class: "inline-flex items-center justify-center border-gray-800 border-2 text-md hover:shadow-lg transition-all rounded-lg px-6 py-3.5 leading-tight bg-white text-gray-800 tracking-tighter",
          onClick: signOut
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", null, "Learn more", -1)
        ]))]),
        _createElementVNode("button", {
          type: "button",
          class: "ml-2 inline-flex items-center border-gray-800 border-2 font-bold text-md hover:shadow-lg transition-all rounded-full px-6 py-3.5 leading-tight bg-yellow-200 text-gray-800",
          onClick: signUp
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "ml-auto transform -translate-y-px mr-4" }, "Start free trial", -1),
          _createElementVNode("span", { class: "mr-auto" }, [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "34",
              height: "13",
              viewBox: "0 0 34 13"
            }, [
              _createElementVNode("path", {
                d: "M3.11,6.82A20,20,0,0,1,1.2,6a.46.46,0,0,0-.67.15A2.32,2.32,0,0,0,0,7.25C0,7.64,0,7.84.3,8c.59.25,1.18.52,1.78.72",
                transform: "translate(0 0)"
              }),
              _createElementVNode("path", {
                d: "M1.83,8.58A23.56,23.56,0,0,0,7.36,10a36.41,36.41,0,0,0,8.79,0A53.55,53.55,0,0,0,29.69,6.72l.19-.07,0,0c-.33.4-.65.8-1,1.19-.72.87-1.45,1.73-2.16,2.61a1.75,1.75,0,0,0,0,2.28.68.68,0,0,0,.52.22.73.73,0,0,0,.5-.26c.67-.78,1.33-1.58,2-2.39l3.65-4.41A2.13,2.13,0,0,0,34,4.5,1.24,1.24,0,0,0,33.91,4a.87.87,0,0,0-.28-.36,1.55,1.55,0,0,0-.32-.2L26.59.11c-.65-.31-1.25.05-1.54.92a1.22,1.22,0,0,0,.4,1.5c.95.49,1.91,1,2.86,1.42l1.78.89-.19.08A55.6,55.6,0,0,1,17.44,8a36.08,36.08,0,0,1-8.87.12A21.78,21.78,0,0,1,2.82,6.7c-.3-.12-.73-.1-1-.25",
                fill: "#000000",
                transform: "translate(0 0)"
              })
            ])
          ], -1)
        ]))])
      ])
    ]),
    _: 1
  }))
}
}

}